function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { isPlainObject } from "../../../shared/utils/isPlainObject.js";
import { extend } from "../../../shared/utils/extend.js";
import { Fullscreen } from "../../../shared/utils/Fullscreen.js";
import { Slideshow } from "../../../shared/utils/Slideshow.js";
var defaults = {
  // What toolbar items to display
  display: ["counter", "zoom", "slideshow", "fullscreen", "thumbs", "close"],
  // Only create a toolbar item if there is at least one image in the group
  autoEnable: true,
  // Toolbar items; can be links, buttons or `div` elements
  items: {
    counter: {
      type: "div",
      class: "fancybox__counter",
      html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
      tabindex: -1,
      position: "left"
    },
    prev: {
      type: "button",
      class: "fancybox__button--prev",
      label: "PREV",
      html: '<svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg>',
      click: function click(event) {
        event.preventDefault();
        this.fancybox.prev();
      }
    },
    next: {
      type: "button",
      class: "fancybox__button--next",
      label: "NEXT",
      html: '<svg viewBox="0 0 24 24"><path d="M8 4l8 8-8 8"/></svg>',
      click: function click(event) {
        event.preventDefault();
        this.fancybox.next();
      }
    },
    fullscreen: {
      type: "button",
      class: "fancybox__button--fullscreen",
      label: "TOGGLE_FULLSCREEN",
      html: "<svg viewBox=\"0 0 24 24\">\n                <g><path d=\"M3 8 V3h5\"></path><path d=\"M21 8V3h-5\"></path><path d=\"M8 21H3v-5\"></path><path d=\"M16 21h5v-5\"></path></g>\n                <g><path d=\"M7 2v5H2M17 2v5h5M2 17h5v5M22 17h-5v5\"/></g>\n            </svg>",
      click: function click(event) {
        event.preventDefault();

        if (Fullscreen.element()) {
          Fullscreen.deactivate();
        } else {
          Fullscreen.activate(this.fancybox.$container);
        }
      }
    },
    slideshow: {
      type: "button",
      class: "fancybox__button--slideshow",
      label: "TOGGLE_SLIDESHOW",
      html: "<svg viewBox=\"0 0 24 24\">\n                <g><path d=\"M6 4v16\"/><path d=\"M20 12L6 20\"/><path d=\"M20 12L6 4\"/></g>\n                <g><path d=\"M7 4v15M17 4v15\"/></g>\n            </svg>",
      click: function click(event) {
        event.preventDefault();
        this.Slideshow.toggle();
      }
    },
    zoom: {
      type: "button",
      class: "fancybox__button--zoom",
      label: "TOGGLE_ZOOM",
      html: '<svg viewBox="0 0 24 24"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
      click: function click(event) {
        event.preventDefault();
        var panzoom = this.fancybox.getSlide().Panzoom;

        if (panzoom) {
          panzoom.toggleZoom();
        }
      }
    },
    download: {
      type: "link",
      label: "DOWNLOAD",
      class: "fancybox__button--download",
      html: '<svg viewBox="0 0 24 24"><path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.62 2.48A2 2 0 004.56 21h14.88a2 2 0 001.94-1.51L22 17"/></svg>',
      click: function click(event) {
        event.stopPropagation();
      }
    },
    thumbs: {
      type: "button",
      label: "TOGGLE_THUMBS",
      class: "fancybox__button--thumbs",
      html: '<svg viewBox="0 0 24 24"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
      click: function click(event) {
        event.stopPropagation();
        var thumbs = this.fancybox.plugins.Thumbs;

        if (thumbs) {
          thumbs.toggle();
        }
      }
    },
    close: {
      type: "button",
      label: "CLOSE",
      class: "fancybox__button--close",
      html: '<svg viewBox="0 0 24 24"><path d="M20 20L4 4m16 0L4 20"></path></svg>',
      tabindex: 0,
      click: function click(event) {
        event.stopPropagation();
        event.preventDefault();
        this.fancybox.close();
      }
    }
  }
};
export var Toolbar = /*#__PURE__*/function () {
  function Toolbar(fancybox) {
    var _this = this;

    _classCallCheck(this, Toolbar);

    this.fancybox = fancybox;
    this.$container = null;
    this.state = "init";

    for (var _i = 0, _arr = ["onInit", "onPrepare", "onDone", "onKeydown", "onClosing", "onChange", "onSettle", "onRefresh"]; _i < _arr.length; _i++) {
      var methodName = _arr[_i];
      this[methodName] = this[methodName].bind(this);
    }

    this.events = {
      init: this.onInit,
      prepare: this.onPrepare,
      done: this.onDone,
      keydown: this.onKeydown,
      closing: this.onClosing,
      // Clear Slideshow when user strts to change current slide
      "Carousel.change": this.onChange,
      // Set timer after carousel changes current slide; deactive if last slide is reached
      "Carousel.settle": this.onSettle,
      // Deactivate Slideshow on user interaction
      "Carousel.Panzoom.touchStart": function CarouselPanzoomTouchStart() {
        return _this.onRefresh();
      },
      "Image.startAnimation": function ImageStartAnimation(fancybox, slide) {
        return _this.onRefresh(slide);
      },
      "Image.afterUpdate": function ImageAfterUpdate(fancybox, slide) {
        return _this.onRefresh(slide);
      }
    };
  }

  _createClass(Toolbar, [{
    key: "onInit",
    value: function onInit() {
      // Disable self if current group does not contain at least one image
      if (this.fancybox.option("Toolbar.autoEnable")) {
        var hasImage = false;

        var _iterator = _createForOfIteratorHelper(this.fancybox.items),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.type === "image") {
              hasImage = true;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!hasImage) {
          this.state = "disabled";
          return;
        }
      } // Disable the creation of a close button, if one exists in the toolbar


      var _iterator2 = _createForOfIteratorHelper(this.fancybox.option("Toolbar.display")),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var id = isPlainObject(key) ? key.id : key;

          if (id === "close") {
            this.fancybox.options.closeButton = false;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "onPrepare",
    value: function onPrepare() {
      // Skip if disabled
      if (this.state !== "init") {
        return;
      }

      this.build();
      this.update();
      this.Slideshow = new Slideshow(this.fancybox);

      if (!this.fancybox.Carousel.prevPage) {
        if (this.fancybox.option("slideshow.autoStart")) {
          this.Slideshow.activate();
        }

        if (this.fancybox.option("fullscreen.autoStart") && !Fullscreen.element()) {
          try {
            Fullscreen.activate(this.fancybox.$container);
          } catch (error) {}
        }
      }
    }
  }, {
    key: "onFsChange",
    value: function onFsChange() {
      window.scrollTo(Fullscreen.pageXOffset, Fullscreen.pageYOffset);
    }
  }, {
    key: "onSettle",
    value: function onSettle() {
      if (this.Slideshow && this.Slideshow.isActive()) {
        if (this.fancybox.getSlide().index === this.fancybox.Carousel.slides.length - 1 && !this.fancybox.option("infinite")) {
          this.Slideshow.deactivate();
        } else if (this.fancybox.getSlide().state === "done") {
          this.Slideshow.setTimer();
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.update();

      if (this.Slideshow && this.Slideshow.isActive()) {
        this.Slideshow.clearTimer();
      }
    }
  }, {
    key: "onDone",
    value: function onDone(fancybox, slide) {
      if (slide.index === fancybox.getSlide().index) {
        this.update();

        if (this.Slideshow && this.Slideshow.isActive()) {
          if (!this.fancybox.option("infinite") && slide.index === this.fancybox.Carousel.slides.length - 1) {
            this.Slideshow.deactivate();
          } else {
            this.Slideshow.setTimer();
          }
        }
      }
    }
  }, {
    key: "onRefresh",
    value: function onRefresh(slide) {
      if (!slide || slide.index === this.fancybox.getSlide().index) {
        this.update();

        if (this.Slideshow && this.Slideshow.isActive() && (!slide || slide.state === "done")) {
          this.Slideshow.deactivate();
        }
      }
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(fancybox, key, event) {
      if (key === " " && this.Slideshow) {
        this.Slideshow.toggle();
        event.preventDefault();
      }
    }
  }, {
    key: "onClosing",
    value: function onClosing() {
      if (this.Slideshow) {
        this.Slideshow.deactivate();
      }

      document.removeEventListener("fullscreenchange", this.onFsChange);
    }
    /**
     * Create link, button or `div` element for the toolbar
     * @param {Object} obj
     * @returns HTMLElement
     */

  }, {
    key: "createElement",
    value: function createElement(obj) {
      var $el;

      if (obj.type === "div") {
        $el = document.createElement("div");
      } else {
        $el = document.createElement(obj.type === "link" ? "a" : "button");
        $el.classList.add("carousel__button");
      }

      $el.innerHTML = obj.html;
      $el.setAttribute("tabindex", obj.tabindex || 0);

      if (obj.class) {
        var _$el$classList;

        (_$el$classList = $el.classList).add.apply(_$el$classList, _toConsumableArray(obj.class.split(" ")));
      }

      if (obj.label) {
        $el.setAttribute("title", this.fancybox.localize("{{".concat(obj.label, "}}")));
      }

      if (obj.click) {
        $el.addEventListener("click", obj.click.bind(this));
      }

      if (obj.id === "prev") {
        $el.setAttribute("data-fancybox-prev", "");
      }

      if (obj.id === "next") {
        $el.setAttribute("data-fancybox-next", "");
      }

      var $svg = $el.querySelector("svg");

      if ($svg) {
        $svg.setAttribute("role", "img");
        $svg.setAttribute("tabindex", "-1");
        $svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      }

      return $el;
    }
    /**
     * Create all DOM elements
     */

  }, {
    key: "build",
    value: function build() {
      var _this2 = this;

      this.cleanup();
      var all_items = this.fancybox.option("Toolbar.items");
      var all_groups = [{
        position: "left",
        items: []
      }, {
        position: "center",
        items: []
      }, {
        position: "right",
        items: []
      }];
      var thumbs = this.fancybox.plugins.Thumbs; // 1st step - group toolbar elements by position

      var _iterator3 = _createForOfIteratorHelper(this.fancybox.option("Toolbar.display")),
          _step3;

      try {
        var _loop = function _loop() {
          var key = _step3.value;
          var id = void 0,
              item = void 0;

          if (isPlainObject(key)) {
            id = key.id;
            item = extend({}, all_items[id], key);
          } else {
            id = key;
            item = all_items[id];
          }

          if (["counter", "next", "prev", "slideshow"].includes(id) && _this2.fancybox.items.length < 2) {
            return "continue";
          }

          if (id === "fullscreen") {
            if (!document.fullscreenEnabled || window.fullScreen) {
              return "continue";
            }

            document.addEventListener("fullscreenchange", _this2.onFsChange);
          }

          if (id === "thumbs" && (!thumbs || thumbs.state === "disabled")) {
            return "continue";
          }

          if (!item) {
            return "continue";
          }

          var position = item.position || "right";
          var group = all_groups.find(function (obj) {
            return obj.position === position;
          });

          if (group) {
            group.items.push(item);
          }
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        } // 2st step - create DOM elements

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var $container = document.createElement("div");
      $container.classList.add("fancybox__toolbar");

      for (var _i2 = 0, _all_groups = all_groups; _i2 < _all_groups.length; _i2++) {
        var group = _all_groups[_i2];

        if (group.items.length) {
          var $wrap = document.createElement("div");
          $wrap.classList.add("fancybox__toolbar__items");
          $wrap.classList.add("fancybox__toolbar__items--".concat(group.position));

          var _iterator4 = _createForOfIteratorHelper(group.items),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var obj = _step4.value;
              $wrap.appendChild(this.createElement(obj));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          $container.appendChild($wrap);
        }
      } // Add toolbar container to DOM


      this.fancybox.$carousel.parentNode.insertBefore($container, this.fancybox.$carousel);
      this.$container = $container;
    }
    /**
     * Update element state depending on index of current slide
     */

  }, {
    key: "update",
    value: function update() {
      var slide = this.fancybox.getSlide();
      var idx = slide.index;
      var cnt = this.fancybox.items.length; // Download links
      // ====

      var src = slide.downloadSrc || (slide.type === "image" && !slide.error ? slide.src : null);

      var _iterator5 = _createForOfIteratorHelper(this.fancybox.$container.querySelectorAll("a.fancybox__button--download")),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _$el2 = _step5.value;

          if (src) {
            _$el2.removeAttribute("disabled");

            _$el2.removeAttribute("tabindex");

            _$el2.setAttribute("href", src);

            _$el2.setAttribute("download", src);

            _$el2.setAttribute("target", "_blank");
          } else {
            _$el2.setAttribute("disabled", "");

            _$el2.setAttribute("tabindex", -1);

            _$el2.removeAttribute("href");

            _$el2.removeAttribute("download");
          }
        } // Zoom buttons
        // ===

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var panzoom = slide.Panzoom;
      var canZoom = panzoom && panzoom.option("maxScale") > panzoom.option("baseScale");

      var _iterator6 = _createForOfIteratorHelper(this.fancybox.$container.querySelectorAll(".fancybox__button--zoom")),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _$el3 = _step6.value;

          if (canZoom) {
            _$el3.removeAttribute("disabled");
          } else {
            _$el3.setAttribute("disabled", "");
          }
        } // Counter
        // ====

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var _iterator7 = _createForOfIteratorHelper(this.fancybox.$container.querySelectorAll("[data-fancybox-index]")),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _$el4 = _step7.value;
          _$el4.innerHTML = slide.index + 1;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var _iterator8 = _createForOfIteratorHelper(this.fancybox.$container.querySelectorAll("[data-fancybox-count]")),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _$el5 = _step8.value;
          _$el5.innerHTML = cnt;
        } // Disable prev/next links if gallery is not infinite and reached start/end

      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      if (!this.fancybox.option("infinite")) {
        var _iterator9 = _createForOfIteratorHelper(this.fancybox.$container.querySelectorAll("[data-fancybox-prev]")),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var $el = _step9.value;

            if (idx === 0) {
              $el.setAttribute("disabled", "");
            } else {
              $el.removeAttribute("disabled");
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        var _iterator10 = _createForOfIteratorHelper(this.fancybox.$container.querySelectorAll("[data-fancybox-next]")),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _$el = _step10.value;

            if (idx === cnt - 1) {
              _$el.setAttribute("disabled", "");
            } else {
              _$el.removeAttribute("disabled");
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.Slideshow && this.Slideshow.isActive()) {
        this.Slideshow.clearTimer();
      }

      if (this.$container) {
        this.$container.remove();
      }

      this.$container = null;
    }
  }, {
    key: "attach",
    value: function attach() {
      this.fancybox.on(this.events);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.fancybox.off(this.events);
      this.cleanup();
    }
  }]);

  return Toolbar;
}(); // Expose defaults

Toolbar.defaults = defaults;